<template>
  <el-dialog
    title="申请采购单"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="采购单号">{{model.number}}</el-form-item>
      <el-form-item label="审批人" prop="approver_id">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.approver_id">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  purchaseOrderStatusChange,
  userListByAuthCode,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      users: [],
      rules: {
        approver_id: [{ required: true, message: '请选择审批人' }],
      },
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      let res = await userListByAuthCode({
        auth_code: this.Auth.purchaseOrderApprove.pAuthCode,
      })
      if (res.code == 0) {
        this.users = res.data.list
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await purchaseOrderStatusChange({
            id: this.model.id,
            status: 3,
            approver_id: this.model.approver_id,
          })
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>